module.exports = __webpack_public_path__ + "static/media/circle-solid.fe800bb2.svg";